import React from 'react';
import type { FC } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Container,
  Grid,
  Typography,
  makeStyles,
  Button,
} from '@material-ui/core';
import type { Theme } from 'src/theme';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import Background from '../../../../public/static/home/slider_image_1.jpg';
interface HeroProps {
  className?: string;
  executeScroll: () => void;
}

const slideImages = [
  {
    url: '/static/home/slider_image_1.jpg',
    title: 'Finally, your worry free life',
    title2: 'is just around the corner.',
    caption: 'Enjoy what matters most by taking away loans faster.'  
  },
  {
    url: '/static/home/slider_image_2.jpg',
    title: 'Life begins today',
    caption: 'Loans should not take your whole life away.',
    caption2: 'Start paying debts smarter and faster.'
  }
];


const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    // backgroundImage: `url(${process.env.PUBLIC_URL + '/static/home/person_1.png'})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    // paddingTop: 200,
    // paddingBottom: 200,
    // [theme.breakpoints.down('md')]: {
    //   paddingTop: 60,
    //   paddingBottom: 60
    // }
  },
  technologyIcon: {
    height: 40,
    margin: theme.spacing(1)
  },
  image: {
    borderBottomLeftRadius: 400,
    // backgroundColor: theme.palette.primary.main,
    // transition: '0.4s cubic-bezier(1, -1, 0, 2)',
    // clipPath: 'polygon(20% 5%, 0% 100%, 100% 100%)',
    // perspectiveOrigin: 'left center',
    // transformStyle: 'preserve-3d',
    // perspective: 1500,
    '& > img': {
      maxWidth: '90%',
      height: 'auto',
      // transform: 'rotateY(-35deg) rotateX(15deg)',
      // backfaceVisibility: 'hidden',
      // boxShadow: theme.shadows[16]
    }
  },
  shape: {
    position: 'absolute',
    top: 0,
    left: 0,
    '& > img': {
      maxWidth: '90%',
      height: 'auto'
    }
  },
  slideContainer: {
    padding: 0,
  },
  titleBox: {
     [theme.breakpoints.down('md')]: {
      paddingLegt: 60,
    }
  }
}));

const Hero: FC<HeroProps> = ({ className, executeScroll, ...rest }) => {
  const classes = useStyles();

  const Slideshow = () => {
    return (
      <div className="slideContainer">
        <Slide>
         {slideImages.map((slideImage, index)=> (
            <div key={index}>
              <div style={{ backgroundImage: `url(${slideImage.url})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', height: 700, backgroundPosition: 'right'}}>
                <Grid
                  container
                  spacing={3}
                >
                  <Grid
                    item
                    xs={12}
                    md={5}
                    lg={7}
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      height="100%"
                      style={{ marginTop: 80, alignItems: 'center' }}
                      className={classes.titleBox}
                    >
                      <Box>
                        <img
                          alt="Icon"
                          src={'/static/icon.png'}
                          style={{ height: 18, width: 30, marginBottom: 20 }}
                        />
                        <Typography
                          variant="h1"
                          color="primary"
                          style={{ fontWeight: 'bolder' }}
                        >
                          {slideImage?.title}
                        </Typography>
                        { slideImage?.title2 && 
                          <Typography
                            variant="h1"
                            color="primary"
                            style={{ fontWeight: 'bolder' }}
                          >
                            {slideImage?.title2}
                          </Typography> 
                        }
                        <Box>
                          {/* <Typography
                            variant="body1"
                            color="textSecondary"
                          >
                            Understanding Capital, Liabilities & Equity.
                          </Typography> */}
                          {/* <Typography
                            variant="body1"
                            color="textSecondary"
                          >
                            DEBT steals away your choices, but being DEBT-FREE gives them back to you.
                          </Typography> */}
                          <Typography
                            variant="body1"
                            color="textSecondary"
                            style={{ marginTop: 20, fontFamily: 'Poppins'}}
                          >
                            {slideImage?.caption}  
                          </Typography>
                          { slideImage?.caption2 && 
                            <Typography
                              variant="body1"
                              color="textSecondary"
                              style={{ fontFamily: 'Poppins'}}
                            >
                              {slideImage?.caption2}  
                            </Typography>
                          }
                          <Button variant='contained' color='primary' style={{ marginTop: 20}} onClick={executeScroll}>
                            Get Early Access
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </div>
            </div>
          ))} 
        </Slide>
      </div>
    )
};

  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >
      <div>
        <Slideshow />
      </div>
    </div>
  );
};

Hero.propTypes = {
  className: PropTypes.string
};

export default Hero;
